module.exports = __webpack_public_path__ + "static/uncommon-d0a9076c1033e477b4a085fe2502e2a0.png";